module.exports = __webpack_public_path__ + "static/kitchen_2K-32ffbb6b5df2ffee6c62c07cd701f108.webp";